export default __webpack_public_path__ + "static/media/icon-calendar.7cd1d421.svg";